import React from 'react';
import { SRLWrapper } from "simple-react-lightbox";
import {
        makeStyles,
        GridList,
        GridListTile,
        Card,
        Typography,
        Grid,
} from '@material-ui/core/';
import tileData from './tileData';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 1000,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: '-5%',
    marginBottom: '5%',
  },
  gridList: {
    padding: 30,
  },
  gridListTile: {
    height: '200px !important',
  },
}));

export default function ImageGridList() {
  const classes = useStyles();

  return (
    <Grid className='galleryContainer' container justify='center' >
      <Card className={classes.root}>

        <Typography className={classes.gridList} variant="h4" color='textSecondary' >
          GALERIE
        </Typography>
        <SRLWrapper>
          <GridList cellHeight={160} className={classes.gridList} cols={3}>
            {tileData.map((tile) => (
              <GridListTile className={classes.gridListTile} key={tile.img} cols={tile.cols || 1}>
                <img className='galleryImg' src={tile.img} alt={tile.title} />
              </GridListTile>
            ))}
          </GridList>
        </SRLWrapper>
      </Card>
    </Grid>
  );
}